import validLicensePresent from "license/ValidLicensePresent";
import ExecuteViewWithValue from "enterprise/parameters/components/views/ExecuteViewWithValue";
import { MISSING_BUCKET_NAME } from "views/Constants";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
export const InsertIntoViewValueActionPlugin = {
  type: "execute-view-with-value",
  title: "Insert into dashboard/search",
  isEnabled: ({ value, contexts }) => value !== MISSING_BUCKET_NAME && !hasMultipleValueForActions(contexts),
  component: ExecuteViewWithValue,
  condition: validLicensePresent
};
